import Oppsummering from "./Oppsummering";
import { useRegistreringContext } from "../Registreringsflyt/useRegistreringContext";
import { Organisasjonsnummer } from "../Organisasjonsnummer/Organisasjonsnummer";
import { SummaryPoint } from "./OppsummeringBody";

export function RegistreringsFlytOppsummering() {
  const {
    kontaktInfo,
    integrasjonsPartner,
    valgtForetak,
    registrer,
    previousStep,
    reset,
    isRegistering,
  } = useRegistreringContext();

  if (!kontaktInfo || !valgtForetak) {
    return reset();
  }

  const summaryPoints = [
    {
      headerKey: "generic.business" as const,
      values: [
        kontaktInfo?.virksomhetsNavn,
        <Organisasjonsnummer orgNr={valgtForetak.foretak.orgnummer} />,
        kontaktInfo.companyEmail,
      ],
    },
    {
      headerKey: "contact.email_personal" as const,
      values: [kontaktInfo.personalEmail],
    },
    integrasjonsPartner
      ? {
          headerKey: "partneronboarding.system_provider",
          values: [
            integrasjonsPartner.orgName,
            <Organisasjonsnummer orgNr={integrasjonsPartner.orgNumber} />,
          ],
        }
      : undefined,
  ].filter((p) => p !== undefined) as SummaryPoint[];

  return (
    <Oppsummering
      goBack={previousStep}
      submitAction={registrer}
      submitTextKey="summary.register_button"
      summaryPoints={summaryPoints}
      showTermsCheckbox={!integrasjonsPartner}
      isSubmitting={isRegistering}
    />
  );
}
